
import { enviar } from "../services/pedidos.services"

const agruparPedidos = async (seleccionadosParam, setModal, IdEmp, headers, urlInvoiceApi, proveedor, idProveedor) => {
    /* 
       0-encontrar los diferentes numeros de envio que hay, guardarlos en un array unico con set
       1-por cada diferente numero, crear un array direfente
    */
       let obj = {}
       // sacar los diferentes numeros
       const numeros = Array.from(new Set(seleccionadosParam.map(e => e.IdPedido)))
       //obj.numeros = numeros
       // crear una key por cada numero diferente
       numeros.forEach(e => Object.defineProperty(obj, `${e}`, {value:[], enumerable:true}) )
       // agregar los items corespondientes a su número
       numeros.forEach(e => obj[e].push(seleccionadosParam.filter(f => f.IdPedido === e)))
       let envios = formatear(obj, IdEmp, proveedor, idProveedor)
       let mensajesPedidos = await enviar(envios, headers, urlInvoiceApi)
       let estadoMensajes = mensajesPedidos.every(e => e === "0")
       if(estadoMensajes){
        setModal({
          show: true,
          ok: true,
          msg: "Transacción terminada con éxito",
          reload:true
        })
       }else{
        setModal({
          show: true,
          ok: false,
          reaload: true,
          msg: "No se pudo completar la operación"
        })
       }
}

const formatear = (objParam, IdEmp, proveedor, idProveedor) => {
    // por cada key de numeros, enviar un post
    // crear un campo envios:Array que va a contener un objeto completo 
    let arr = []
    Object.keys(objParam).forEach(e => {
      arr.push(
        {
          "IdProveedor": parseInt(idProveedor || proveedor),
          "IdPedido": parseInt(objParam[e][0][0].IdPedido),
          "FechaEnvio":objParam[e][0][0].FechaEnvio, // una misma fecha para todos, tomar el del indice 0 y convertirla "20240729"
          "IdEmp": IdEmp,
          "HostName": "DEV07",
          "IpHost": "131.107.1.235",
          "OS": "Windows",
          "Productos": {
            "Productos": filtrado(Object.values(objParam)[0][0][0], Object.values(objParam)[0][0][0].Productos.filter(e => e.selected))
          }
        })
    })
    return arr
}

const filtrado = (padre, arrayParam) => {
    let elements = []
    let array = structuredClone(arrayParam);
    array?.forEach((e, index) => {
      elements.push({
        "IdSede":      padre.IdSede,
        "IdProdProv":  e["IdProdProv"],
        "IdProducto":  e["IdProducto"],
        "IdBodega":    padre.IdBodega,
        "Cantidad":    e["Cantidad"],
        "Costo":       e["Costo"],
        "NoEnvioProv": e["NoEnvioProv"],
      }) 
    }
    );
    return elements
}

const currentMonth = () => {
  return new Date().getMonth() + 1
}

const getCurrentDate = () => {
  const date = new Date();
  return `${date.getFullYear()}-${currentMonth().toString().padStart(2,"0")}-${new Date().getDate().toString().padStart(2, "0")}`
}

export {
    agruparPedidos,
    getCurrentDate
}